import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';

export function* getRefPayments() {
  try {
    const res = yield call(api, {
      method: 'get',
      url: URL.REF_PAYMENTS,
    });
    const { data } = res;
    yield put({ type: 'GET_REF_PAYMENTS_SUCCESS', data });
  } catch (e) {
    yield put({ type: 'GET_REF_PAYMENTS_ERROR' });
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.GET_REF_PAYMENTS, getRefPayments);
}
